import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class ReSendOTPCodeService {

  constructor(
    private http: HttpClient
  ) { }

  reSendCode(idDocumentoPagare_: string, tipoDocumento_: string, numeroDocumento_: string
    , idRolFirmante_: string, idSolicitud_: string) {
    const body ={ idDocumentoPagare: idDocumentoPagare_.toString(),
      tipoDocumento : tipoDocumento_.toString(),
      numeroDocumento : numeroDocumento_.toString(),
      idRolFirmante : idRolFirmante_.toString(),
      idSolicitud : idSolicitud_.toString()
    };

    const headers = new HttpHeaders({ 'Authorization':`Bearer ${localStorage.getItem('tokenId')}`, 'Content-Type':'application/json' });

    return this.http.post(`https://www.mundofinanciera.com:9091/api/mf/reenvioOtp/`, body, { headers, observe: 'response' });
  }
}
